import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { PREFECTURES } from '../../const'
import { postFormWithImage, showToast, fetchDetails, resetForm } from '../../actions'
import RegularDropdown from '../_common/RegularDropdown'
import RoleControlled from '../_common/RoleControlled'

class EditProperty extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      owner_id: '',
      // name: '',
      bits_property_id: '',
      property_name: '',
      pref_id: '',
      address: '',
      room_count: '',
      image: '',
      image_url: '',
      image_error: '',
      memo: ''
    }
  }

  componentDidMount () {
    this.props.resetForm()
    const {
      property_id,
      owner_id,
      bits_property_id,
      property_name,
      pref_id,
      address,
      room_count,
      memo,
      image
    } = this.props.data
    this.setState({
      id: property_id,
      owner_id,
      bits_property_id,
      property_name,
      pref_id,
      address,
      room_count: room_count || '',
      memo: memo || '',
      image_url: image
    })
  }

  _handleContentChange (key, e) {
    this.setState({ [key]: e.target.value })
  }
  _handlePrefectureChange (val) {
    const id = _.find(PREFECTURES, { name: val }).code
    this.setState({ pref_id: id })
  }

  async _handleImageChange (e) {
    console.log('image changing')
    const image = e.target.files[0]
    if (image) {
      if (
        (image.type === 'image/png' || image.type === 'image/jpeg' || image.type === 'image/jpeg') &&
        (image.name.indexOf('png') > 0 || image.name.indexOf('jpeg') > 0 || image.name.indexOf('jpg') > 0)
      ) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.setState({image_url: e.target.result})
        }
        reader.readAsDataURL(e.target.files[0])
        this.setState({ image })
      } else {
        this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }

  _handleFormSubmit (e) {
    e.preventDefault()
    if (!this.props.post.loading) {
      console.log('submit')
      if (!this.state.pref_id) {
        console.log('no pref')
        this.props.showToast('都道府県を選択してください。', 'danger')
      } else {
        console.log('sending')
        const data = _.omit(this.state, ['owner_name', 'image', 'image_error', 'image_url'])
        // const redirect = function () {
        //   this.props.history.push(`/properties/${this.state.id}`)
        // }
        const redirect = function () {
          this.props.fetchDetails('properties', this.props.data.property_id)
        }
        console.log('id: ', this.props.data.property_id)
        this.props.postFormWithImage('properties', data, this.state.image, redirect.bind(this))
        this.props.save()
      }
    }
  }

  _resetImage () {
    this.setState({ image: '', image_url: '' })
    document.getElementById('image').value = ''
  }

  _renderImageLabel () {
    if (this.state.image_url) {
      return (
        <div className="label_container">
          <label className="image_input_label image_selected" htmlFor="image">
            <img className="img-responsive" src={this.state.image_url} alt=""/>
          </label>
          <div className="delete_container" onClick={this._resetImage.bind(this)}>
            <span></span>
            <span></span>
          </div>
        </div>
      )
    }
    return (
      <div className="label_container">
        <label className="image_input_label image_blank" htmlFor="image">
          <svg className="add" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="16"></line>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
        </label>
      </div>
    )
  }

  _renderForm () {
    // if (!this.props.push.loading) {
    const prefectureName = _.find(PREFECTURES, { code: this.state.pref_id }) ? _.find(PREFECTURES, { code: this.state.pref_id }).name : '選択して下さい'
    return (
      <form onSubmit={ this._handleFormSubmit.bind(this) }>
        <RoleControlled role={this.props.user.user_role} acceptedRoles={[0]}>
          <div className="input-group flex column">
            <label className="label required" htmlFor="bits_id">BITS物件ID</label>
            <input
              type="text"
              id="bits_id"
              className="small_input"
              placeholder="BITS物件ID"
              value={this.state.bits_property_id}
              onChange={this._handleContentChange.bind(this, 'bits_property_id')}
              required
            />
          </div>

          <div className="input-group flex column">
            <label className="label required" htmlFor="property_name">物件名</label>
            <input
              type="text"
              id="property_name"
              className="medium_input"
              placeholder="物件名"
              value={this.state.property_name}
              onChange={this._handleContentChange.bind(this, 'property_name')}
              required
            />
          </div>

          <div className="input-group flex column">
            <label className="label required" htmlFor="prefecture">都道府県</label>
            <RegularDropdown
              selected={ prefectureName }
              choices={ PREFECTURES.map(pref => pref.name) }
              updateTerm={this._handlePrefectureChange.bind(this)}
            />
          </div>

          <div className="input-group flex column">
            <label className="label required" htmlFor="address">住所</label>
            <input
              type="text"
              id="address"
              className="large_input"
              placeholder="住所"
              value={this.state.address}
              onChange={this._handleContentChange.bind(this, 'address')}
              required
            />
          </div>

          <div className="input-group flex column">
            <label className="label" htmlFor="room_count">
              総世帯数
              <small>（半角数字のみ）</small>
            </label>
            <input
              type="number"
              id="room_count"
              className="medium_input"
              placeholder="総世帯数"
              value={this.state.room_count}
              onChange={this._handleContentChange.bind(this, 'room_count')}
            />
          </div>
        </RoleControlled>

        <div className="input-group flex column">
          <label className="label" htmlFor="image">
            画像
            <span className="smallest">（JPEG・PNGファイルのみ）</span>
          </label>
          <div className="image_input_container flex">
            { this._renderImageLabel() }
            <div>
              <div className="image_error small">{ this.state.image_error }</div>
              <input
                type="file"
                id="image"
                onChange={this._handleImageChange.bind(this)}
              />
            </div>
          </div>
        </div>
        <RoleControlled role={this.props.user.user_role} acceptedRoles={[0]}>
          <div className="input-group flex column">
            <label className="label" htmlFor="memo">メモ</label>
            <textarea
              id="memo"
              className="large_input"
              value={this.state.memo}
              onChange={this._handleContentChange.bind(this, 'memo')}
            >
            </textarea>
          </div>
        </RoleControlled>

        <div className="button_container flex justify-center">
          <button className="btn cancel_btn" type="button" onClick={ this.props.close }>キャンセル</button>
          <button className="btn submit_btn" type="submit">保存</button>
        </div>

      </form>
    )
    // }
    // return <Loader classname="loader_dot_circle"/>
  }

  render () {
    // if (this.props.push && this.props.push.postSuccess) {
    //   return <Redirect to='/push' />
    // }
    return (
      <section className="property_form add_form">
        <h4 className="page_title bold">物件編集</h4>
        { this._renderForm() }
      </section>
    )
  }
}

function mapStateToProps ({ user, post }) {
  return { user, post }
}

export default withRouter(connect(mapStateToProps, { postFormWithImage, showToast, fetchDetails, resetForm })(EditProperty))
// export default AddOwner



// WEBPACK FOOTER //
// ./src/components/Properties/EditProperty.js